import React from 'react';

import {
	aquamationContent,
	aquamationTitle,
	differenceContent,
	differenceTitle,
	howDoesContent,
	howDoesTitle,
	videoSrc,
	whatCanContent,
	whatCanTitle,
	whatIsContent,
	whatIsTitle,
} from '@app/components/Pages/Services/Aftercare/Aquamation/AquamationContent';
import CardPhoto from '@app/components/UI/CardPhoto/CardPhoto';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';

const Aquamation = () => {
	return (
		<HelmetProvider>
			<div>
				<Masthead title={aquamationTitle} imageSrc={require('@app/content/aftercare-aquamation.jpg')} />
				<RichText text={aquamationContent} />
				<RichText title={whatIsTitle} text={whatIsContent} />
				<CardPhoto imgURL={require('@app/content/aquamation.jpg')} title={<>&nbsp;</>} />

				<RichText title={howDoesTitle} text={howDoesContent} />
				<RichText title={differenceTitle} text={differenceContent} />
				<RichText title={whatCanTitle} text={whatCanContent} />
				<VideoEmbed videoSrc={videoSrc} />
			</div>
		</HelmetProvider>
	);
};

export default Aquamation;
